// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/MensagensProgramadasLote_BuscaDadosInput.php
// Do not edit by hand — edit the PHP InputContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * InputContract for POST /mensagens_programadas_lote/buscaDados
 *
 * No body required — endpoint uses the session filter to fetch bulk operations.
 */
import { registerContract } from './validate'

export interface MensagensProgramadasLote_BuscaDadosInput {}

registerContract('MensagensProgramadasLote_BuscaDadosInput', {})
